/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaypointName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaypointName({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/PaypointName"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let providerAccountDescriptionNameValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'description.name',
})
  return (<React.Fragment
>
<div
  data-testid="PaypointName.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1LT787': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={130}
 color={dtColorsNeutral500}
 text="Paypoint name"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 width={200}
 data="provider_account.description.name"
 text={providerAccountDescriptionNameValueData}
/>
</div>
{children}
</React.Fragment>)
}